module.exports = __webpack_public_path__ + "img/home_inactive.c2c66743.svg";